<div class="d-flex flex-wrap align-items-start mb-6">
  <label class="col-12 col-lg-4 col-form-label" [class.required]="required">{{ label }}</label>
  <div class="col-12 col-lg-8">
    <div class="mb-2" *ngIf="valueFormGroup.value && valueFormGroup.value.length">
      <app-chips-legacy [chipsList]="valueFormGroup.value"
                 (removeSelectDataOutput)="handleRemoveSelectData($event)"></app-chips-legacy>
    </div>

    <button
      type="button"
      class="btn bg-transparent"
      [ngClass]="{
        'btn-outline': btnStyleOutline,
        'btn-outline--disabled': btnStyleDisabled
      }"
      (click)="handleOpenModalForm()"
      [disabled]="btnStyleDisabled"
    >
      <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_PLUS" class="svg-icon svg-icon-2"></span>
      <span class="text-primary" [ngClass]="{ 'text-gray-300': btnStyleDisabled }">{{ ctaLabelOpenModalForm }}</span>
    </button>
  </div>
</div>


<!--<app-modal-form #modalForm [modalConfig]="modalFormConfig" *ngIf="valueFormGroup.value">-->
<!--  <div *ngIf="valueFormGroup.value.length" class="mb-4">-->
<!--    <app-chips-legacy [chipsList]="valueFormGroup.value" (dataOutput)="handleDataOutput($event)"></app-chips-legacy>-->
<!--  </div>-->

<!--  <ng-container *ngIf="valueFormGroup.value.length; else noDataTpl">-->
<!--    <div class="multiselect-search mb-4">-->
<!--      <div class="input-group">-->
<!--        <input type="text" class="form-control" placeholder="Silahkan cari {{ searchLabel }} disini" [(ngModel)]="searchKeyword" />-->
<!--        <span class="input-group-text">-->
<!--          <span [inlineSVG]="'./assets/media/icons/ic_search.svg'" class="svg-icon svg-icon-2"></span>-->
<!--        </span>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="multiselect-list mh-200px overflow-auto mb-4">-->
<!--      <div *ngFor="let item of listbox_listItems.value | filter : searchKeyword" class="form-check my-6 text-capitalize">-->
<!--        <input class="form-check-input cursor-pointer" type="checkbox" id="flexCheckDefault-{{ item.id }}" (change)="handleChangeSelection()" [(ngModel)]="item.selected" />-->
<!--        <label for="flexCheckDefault-{{ item.id }}" class="form-check-label cursor-pointer ms-2 text-gray-900 text-capitalize">{{ item.name | lowercase }}</label>-->
<!--        <span *ngIf="haveDescription">-->
<!--          <br />-->
<!--          <label for="flexCheckDefault-{{ item.id }}" class="form-check-label cursor-pointer ms-2 text-gray-900 text-capitalize">{{ item[descriptionKey] | lowercase }}</label>-->
<!--        </span>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="d-flex justify-content-end">-->
<!--      <button type="button" class="btn btn-primary" (click)="handleAddChipsList()" [disabled]="!listbox_selectedItems.value.length">-->
<!--        {{ ctaLabelAddItems }}-->
<!--      </button>-->
<!--    </div>-->
<!--  </ng-container>-->

<!--  <ng-template #noDataTpl>-->
<!--    <p class="px-7">Tidak ada data...</p>-->
<!--  </ng-template>-->
<!--</app-modal-form>-->
